var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isVisible)?_c('div',{staticClass:"pills"},_vm._l((_setup.pills),function(pill){return _c('button',{key:pill,staticClass:"pill",class:{ active: pill === _vm.selected },attrs:{"type":"button"},on:{"click":function($event){return _setup.emit('change', pill)}}},[_vm._v(_vm._s(pill))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }